export const ADMIN='ADMIN'
export const PROJECT_COORDINATOR='PROJECT_COORDINATOR'
export const CLIENT='CLIENT'
export const CLIENT_VENDOR='CLIENT_VENDOR'
